import { render, staticRenderFns } from "./UploadedFont.vue?vue&type=template&id=6deb47a6"
import script from "./UploadedFont.vue?vue&type=script&lang=js"
export * from "./UploadedFont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports